const model = {
    baseUnitDetails: null,
    loading: false,
    error: null,
};

export default model;
